export default __webpack_public_path__ + "../staticImages/payment_logo_americanexpress.png";